export default __webpack_public_path__ + "static/media/WAGMI Index.9738fdd7.png";